import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { createRootErrorHandlers, ErrorBoundary, ErrorFallback, initRum } from "@recruiter/shared";

import { RUM_SAMPLE, SELLER_API_BASE } from "./config";

// Design tokens load in two tiers, in order (doctrine — see frontend/ARCHITECTURE.md):
// 1. Generated primitives + typography — must load FIRST so the semantic aliases resolve.
import "@recruiter/shared/tokens/variables.css";
// 2. Semantic --rc-color-* aliases (defined against the primitive tier above).
import "@recruiter/shared/tokens.css";
// 3. App-level globals (built on the semantic tier). The talent platform is NEW UI,
//    so — unlike admin — it does NOT copy web's big ported globals.
import "./globals.css";

import { App } from "./App";

// Real User Monitoring: the talent SPA is a cross-origin CDN, so RUM POSTs via
// keepalive fetch (credentials omitted) to the absolute API origin — not a
// same-origin beacon. Backend CORS-allowlists the seller origin.
initRum({ app: "seller", endpoint: SELLER_API_BASE, transport: "fetch", sampleRate: RUM_SAMPLE });

const root = document.getElementById("root");
if (!root) throw new Error("missing #root element");

createRoot(root, import.meta.env.PROD ? createRootErrorHandlers("seller") : undefined).render(
  <StrictMode>
    <ErrorBoundary
      fallbackRender={() => (
        <ErrorFallback
          variant="page"
          title="Something went wrong"
          message="Reload the page to try again."
          primaryAction={{ label: "Reload page", onClick: () => window.location.reload() }}
        />
      )}
    >
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
